
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/t/[tenantSlug]/w/[workplaceSlug]",
      function () {
        return require("private-next-pages/t/[tenantSlug]/w/[workplaceSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/t/[tenantSlug]/w/[workplaceSlug]"])
      });
    }
  